// Progress percentages for each screen in the THOUGHTS_ON_DOGS section
const thoughtsOnDogsProgress: Record<ThoughtsOnDogsScreenNames, number> = {
	TOD_INTRO: 0,
	E1: 10,
	E2: 20,
	E2_1: 25,
	E3: 30,
	E3_1: 35,
	E3_2: 40,
	E4: 45,
	E4_1: 55,
	E4_2: 65,
	E5: 70,
	E5_1: 75,
	E6: 80,
	E7: 85,
	E7_1: 90,
	E8: 95,
	E9: 100,
};

export const getNextScreenThoughtsOnDogs = (
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	questionSchema: NDS.QuestionSchema,
): NDS.RouteChange => {
	const screenState = surveyState.routeStack[surveyState.routeStack.length - 1];

	switch (screenState.screen as ThoughtsOnDogsScreenNames) {
		// Introduction to Thoughts on Dogs section
		case "TOD_INTRO": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E1",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E1,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Which of these statements best describes you?
		case "E1": {
			const options = questionSchema.THOUGHTS_ON_DOGS.E1.fields[0].options;

			const usedToHaveADogAsAnAdult = options[1].value;

			const userAnswer = formData.nds_q_e1_ownership_history;

			if (userAnswer?.includes(usedToHaveADogAsAnAdult)) {
				// If they used to have a dog as an adult we ask how recently.
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E2",
				});

				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E2,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise straight to do you hope to own a dog in the future.
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E3",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E3,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// How recently did you last have a dog?
		case "E2": {
			const options = questionSchema.THOUGHTS_ON_DOGS.E2.fields[0].options;
			const lessThan12MonthsAgoAnswer = options[0].value;

			const userAnswer = formData.nds_q_e2_how_recent_last_dog;

			if (userAnswer === lessThan12MonthsAgoAnswer) {
				// If it was less than 12 months ago we ask why they no longer have a dog.
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E2_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E2_1,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise straight to do you hope to own a dog in the future.
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E3",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E3,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Why do you no longer have a dog?
		case "E2_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E3",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E3,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Do you hope to own a dog in the future?
		case "E3": {
			const options = questionSchema.THOUGHTS_ON_DOGS.E3.fields[0].options;
			const yesActivelyLookingAnswer = options[0].value;
			const yesInFutureAnswer = options[1].value;
			const noIDoNotWantADogAnswer = options[2].value;

			const userAnswer = formData.nds_q_e3_getting_a_dog;

			if (userAnswer === yesActivelyLookingAnswer) {
				// If they are actively looking for a dog we ask what they are looking for.
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E4",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E4,
				};
				return {
					surveyState,
					formData,
				};
			}
			if (userAnswer === yesInFutureAnswer) {
				// If they want a dog in the future we ask what is holding them back first
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E3_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E3_1,
				};
				return {
					surveyState,
					formData,
				};
			}
			if (userAnswer === noIDoNotWantADogAnswer) {
				// If they do not want a dog we ask why
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E3_2",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E3_2,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise straight to attitudes to dogs
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E6",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E6,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What about your current situation prevents you from owning a dog?
		case "E3_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E4",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E4,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What are your reasons for not wanting to own a dog?
		case "E3_2": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E6",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E6,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What would you look for in your ideal dog?
		case "E4": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E4_1",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E4_1,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What characteristics are most important to you when choosing a dog?
		case "E4_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E4_2",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E4_2,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Additional comments about your ideal dog
		case "E4_2": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E5",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E5,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Where would you search for a new dog?
		case "E5": {
			const options = questionSchema.THOUGHTS_ON_DOGS.E5.fields[0].options;
			const ukBasedRehomingOrganisationAnswer = options[7].value;

			const userAnswer = formData.nds_q_e5_future_source;

			if (!userAnswer?.includes(ukBasedRehomingOrganisationAnswer)) {
				// If they are not looking at UK-based rehoming organisations we ask why
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E5_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E5_1,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise straight to attitudes to dogs
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E6",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E6,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What might be holding you back from getting a dog through a UK-based rehoming organisation?
		case "E5_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E6",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E6,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// How much do you agree or disagree with these statements?
		case "E6": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E7",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E7,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Which areas of our work are you most interested in?
		case "E7": {
			const options = questionSchema.THOUGHTS_ON_DOGS.E7.fields[0].options;
			const fosteringOption = options[0].value;

			const userAnswer = formData.nds_q_e7_campaigns;

			if (userAnswer?.includes(fosteringOption)) {
				// If they are interested in fostering we ask what appeals to them about it
				surveyState.routeStack.push({
					...screenState,
					route: "THOUGHTS_ON_DOGS",
					screen: "E7_1",
				});
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E7_1,
				};
				return {
					surveyState,
					formData,
				};
			}

			// Otherwise straight to challenges and concerns
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E8",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E8,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What appeals to you about fostering a dog?
		case "E7_1": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E8",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E8,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// Do any of these challenges or concerns hold you back from fostering a dog?
		case "E8": {
			surveyState.routeStack.push({
				...screenState,
				route: "THOUGHTS_ON_DOGS",
				screen: "E9",
			});
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: thoughtsOnDogsProgress.E9,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What would you like to see change for dogs?
		case "E9": {
			surveyState.routeStack.push({
				...screenState,
				route: "ABOUT_YOU",
				screen: "AY_INTRO_0",
			});
			// THOUGHTS_ON_DOGS section is complete (100%) when moving to ABOUT_YOU
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				THOUGHTS_ON_DOGS: 100,
				ABOUT_YOU: 0,
			};
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
				transition: "THOUGHTS_ON_DOGS",
			};
		}
	}
};
